module.exports = __webpack_public_path__ + "static/media/27.f6996a03.mp3";